export enum StatusEnum {
  Idle = 'idle',
  Loading = 'loading',
  Processing = 'processing',
  Success = 'success',
  Error = 'error',
}

interface IStateSnapshot {
  initAvaturnUrl: string;
  generatedAvatarId: string;
}

export interface IState {
  avaturnId: string | null;
  stateSnapshot: null | IStateSnapshot;
  status: StatusEnum;

  setAvaturnId: (avaturnId: string | null) => void;
  setStateSnapshot: (initAvaturnUrl: IStateSnapshot | null) => void;
  setStatus: (status: StatusEnum) => void;
}
